export const DEFAULT_PAGE_SIZE = 10;
export const INITIAL_LAST_PAGE = 1;

export const ASSETS_TABLE_HEADERS: string[] = [
  "Site Name",
  "Asset Code",
  "Description",
  "Category",
  "Location of Asset",
  "Install Year",
  "Status",
];

export const ASSETS_BREADCRUMBS = [
  {
    id: null,
    name: "Assets",
  },
];
